<form *ngIf="step === steps.form" [formGroup]="form" [formEditablePermission]="form">
  <div class="row">
    <div class="col-sm-12">
      <mat-form-field class="mat-block">
        <input
          required
          matInput
          type="text"
          formControlName="companyName"
          placeholder="Legal Company Name:"
          i18n-placeholder
        />
        <mat-hint i18n>e.g.: HomeToGo GmbH</mat-hint>
        <mat-error *ngIf="form.get('companyName').touched && form.get('companyName').hasError('required')" i18n>
          Legal Company Name is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input
          required
          matInput
          type="text"
          formControlName="street"
          placeholder="Street Name and Number:"
          i18n-placeholder
        />
        <mat-error *ngIf="form.get('street').touched && form.get('street').hasError('required')" i18n>
          Street Name and Number is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input required matInput type="text" formControlName="zip" placeholder="ZIP/Postal Code:" i18n-placeholder />
        <mat-error *ngIf="form.get('zip').touched && form.get('zip').hasError('required')" i18n>
          ZIP/Postal Code is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input required matInput type="text" formControlName="city" placeholder="City:" i18n-placeholder />
        <mat-error *ngIf="form.get('city').touched && form.get('city').hasError('required')" i18n>
          City is required
        </mat-error>
      </mat-form-field>
      <app-select-search
        [items]="countryList"
        [ctrl]="form.get('countryCode')"
        [multiple]="false"
        bindLabel="name"
        bindValue="id"
        placeholder="Country:"
        i18n-placeholder
      ></app-select-search>
      <mat-form-field class="mat-block">
        <input required matInput type="text" formControlName="vat" placeholder="Company VAT number:" i18n-placeholder />
        <mat-hint i18n
          >Applicable for companies registered in the European Union. Country Code and VAT Number e.g. DE123456789
        </mat-hint>
        <mat-error *ngIf="form.get('vat').touched && form.get('vat').hasError('required')" i18n>
          VAT is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input required matInput type="text" formControlName="email" placeholder="Email:" i18n-placeholder />
        <mat-hint i18n>Email address for all company correspondence</mat-hint>
        <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')" i18n>
          Email is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input required matInput type="text" formControlName="phone" placeholder="Phone:" i18n-placeholder />
        <mat-hint i18n>Phone number for all company correspondence</mat-hint>
        <mat-error *ngIf="form.get('phone').touched && form.get('phone').hasError('required')" i18n>
          Phone is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input matInput type="text" formControlName="website" placeholder="Company website URL:" i18n-placeholder />
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input
          required
          matInput
          type="text"
          formControlName="rentalCount"
          placeholder="Total amount of properties you can provide:"
          i18n-placeholder
        />
        <mat-hint i18n
          >What is the average available inventory you can provide through the Tokeet feed to us at any one
          time?</mat-hint
        >
        <mat-error *ngIf="form.get('rentalCount').touched && form.get('rentalCount').hasError('required')" i18n>
          Total properties is required
        </mat-error>
        <mat-error *ngIf="form.get('rentalCount').touched && form.get('rentalCount').hasError('minNumber')" i18n>
          Total properties must be at least 1
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input
          required
          matInput
          type="text"
          formControlName="location"
          placeholder="Location & distribution of your properties:"
          i18n-placeholder
        />
        <mat-hint i18n>e.g. 20% UK, 10% France, 50% USA, 30% China</mat-hint>
        <mat-error *ngIf="form.get('location').touched && form.get('location').hasError('required')" i18n>
          Location is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block">
        <input
          matInput
          type="text"
          formControlName="additional"
          placeholder="Additional information"
          i18n-placeholder
        />
      </mat-form-field>

      <div class="terms-block" i18n>Terms & Conditions</div>
      <mat-checkbox class="mt-primary mat-block" formControlName="terms" required>
        <ng-container i18n>By checking this box, I am accepting HomeToGo's Partner Integration</ng-container>
        <a target="_blank" href="https://www.hometogo.com/partner-integration/" i18n>Terms &amp; Conditions</a><br />
        <ng-container i18n>on behalf of the entity stated under "Legal Company Name"</ng-container><br /><ng-container
          i18n
          >and I agree to the Partner Integration Terms & Conditions on behalf of the entity</ng-container
        ><br /><ng-container i18n>that I represent.</ng-container>
      </mat-checkbox>
      <mat-error
        style="position: absolute"
        *ngIf="form.get('terms').touched && form.get('terms').hasError('required')"
        i18n
      >
        You have to accept terms and conditions
      </mat-error>
    </div>
    <div class="col-sm-12 submit-block">
      <button
        [disabled]="submitting || (1 | isReadonlyRole)"
        (click)="onFinish(form)"
        type="button"
        class="btn btn-success text-uppercase ml-2"
      >
        <i *ngIf="!submitting" class="fal fa-chevron-right"></i>
        <i *ngIf="submitting" class="fal fa-spinner fa-spin"></i> <ng-container i18n>Next</ng-container>
      </button>
    </div>
  </div>
</form>

<ng-container *ngIf="step === steps.config">
  <app-hometogo-channel-config-form
    [saveText]="'Connect'"
    [title]="'Channel Config'"
    [taxesFees]="'bulk'"
    [channel]="channel"
    [config]="config"
    (save)="onConfigSave($event)"
  ></app-hometogo-channel-config-form>
</ng-container>
